<template>
  <div v-show="showPop">
    <div :class="customClass ? customClass + ' modal-jgg' : 'modal-jgg'">
      <div class="modal-box">
        <div class="modal-title" v-if="showTitle">
          <slot name="tit"></slot>
        </div>
        <div class="md-text-box">
          <slot name="text"></slot>
        </div>
        <div class="footer" v-if="isFooter">
          <span v-if="isConfirm" class="confirmBtn con-buttom" @click="submit">{{confirmText}}</span>
          <span v-if="isCancel" class="confirmCancel con-buttom" @click="tocancel">{{cancelText}}</span>
        </div>
        <i class="btn-close" @click="tocancel"></i>
      </div>
    </div>
    <div @click="tocancel" class="mask-jgg"></div>
  </div>
</template>
<script>
export default {
  name: 'modal',
  data() {
    return {
      showPop: false,
    };
  },
  props: {
    autoClose: {
      default: false,
    },
    showstate: {
      default: false,
    },
    isConfirm: {
      default: false,
    },
    isCancel: {
      default: true,
    },
    confirmText: {
      default: '确定',
    },
    cancelText: {
      default: '取消',
    },
    customClass: {
      default: '',
    },
    showTitle: {
      default: false,
    },
    options: {
      defalut: '',
    },
    isFooter: {
      default: false,
    },
  },
  mounted() {
    // this.autoClose();
    this.showPop = this.showstate;
  },
  methods: {
    tocancel() {
      this.$emit('close');
      this.showPop = false;
    },
    submit() {
      this.$emit('submit');
    },
  },
  watch: {
    showstate(newVal) {
      this.showPop = newVal;
    },
  },
};
</script>
<style lang="stylus">
.mask-jgg {
  position: fixed;
  z-index: 17;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.7;
  left: 0;
  top: 0;
}
.modal-jgg {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  background: #fff;
  border-radius: 8px;
  width: 289px;
  min-height: 373px;
  padding-bottom 30px;
  overflow: hidden;
  .modal-box {
    position: relative;
  }
  .modal-title {
    font-family: "PingFangSC-Medium";
    font-size: 17px;
    color: #000000;
    text-align: center;
    height: 66px;
    line-height: 66px;
    border-bottom: none;
  }
  .md-text-box {
    width: 100%;
    min-height: 230px;
  }

  .btn-close {
    display: block;
    float: right;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 16px;
    height: 16px;
    background: url("../../assets/images/close@2x.png") 0 0 no-repeat;
    background-size: cover;
  }
  .confirmCon {
    padding: 10px 30px 28px;
    font-size: 28px;
    color: #666;
    line-height: 48px;
    max-height: 500rem;
    overflow: scroll;
  }
  .footer {
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 14px;

    .con-buttom {
      display: block;
      margin:0 auto;
      width:199px;
      height: 49px;
      line-height: 49px;
      background-image: linear-gradient(90deg, #82878D 0%, #1A1B1E 100%);
      text-align: center;
      color: #fff;
      font-size: 14px;
      border-radius: 30px;
    }
    .addJg {
      &::before {
        float: left;
        content: "";
        height: 30px;
        border-right: 1px solid #ddd;
        transform: translateY(-50%);
        top: 50%;
        position: relative;
      }
    }
  }
  .btn-box {
    padding-top: 20px;
    .btn {
      display: block;
      width: 500px;
      height: 80px;
      line-height: 80px;
      margin-bottom: 20px;
      font-size: 30px;
      border-radius: 40px;
      overflow: hidden;
      text-decoration: none;
      &.redbtn {
        background-color: #e75d36;
        border: 1px solid #e75d36;
        color: #fff;
        margin: 0 auto 20px auto;
      }
      &.defbtn {
        background-color: #fde5de;
        border: 1px solid #e75d36;
        color: #e75d36;
        margin: 0 auto 20px auto;
      }
    }
  }
}
</style>
